var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-icon",on:{"mouseover":function () { return this$1.$emit('mouseover', { hover: true }); },"mouseleave":function () { return this$1.$emit('mouseleave', { leave: true }); },"click":function () { return this$1.$emit('click', { click: true }); }}})}
var staticRenderFns = []

export { render, staticRenderFns }